var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "field" },
      [
        _vm.label
          ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
          : _vm._e(),
        _c("multiselect", {
          attrs: {
            placeholder: _vm.placeholder,
            "track-by": "id",
            options: _vm.filtered,
            "option-height": 60,
            disabled: !_vm.filtered.length,
            "close-on-select": false,
          },
          on: { select: _vm.addUser },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function (props) {
                return [
                  _c("avatar", {
                    staticClass: "option__img",
                    attrs: {
                      image: props.option.image,
                      cropped: true,
                      size: "is-32x32",
                    },
                  }),
                  _c("div", { staticClass: "option__desc" }, [
                    _c("span", { staticClass: "option__title" }, [
                      _vm._v(
                        _vm._s(props.option.firstname) +
                          " " +
                          _vm._s(props.option.lastname) +
                          " " +
                          _vm._s(
                            props.option.hospitalname
                              ? "— " + props.option.hospitalname
                              : null
                          ) +
                          " "
                      ),
                      props.option.status === "invited"
                        ? _c(
                            "span",
                            {
                              staticClass: "tag is-info is-medium first-letter",
                            },
                            [_vm._v(_vm._s(props.option.status))]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "table",
      { staticClass: "table is-fullwidth" },
      _vm._l(_vm.members, function (member, index) {
        return _c("tr", { key: index }, [
          _c(
            "td",
            { attrs: { width: 40 } },
            [
              _c("avatar", {
                staticClass: "option_img",
                attrs: { image: member.image, cropped: true, size: "is-32x32" },
              }),
            ],
            1
          ),
          _c("td", [_vm._v(_vm._s(_vm.userLabel(member)))]),
          _c("td", { attrs: { width: 80 } }, [
            _c("span", [
              _c(
                "button",
                {
                  staticClass: "button is-small delete-button",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.remove(member)
                    },
                  },
                },
                [_vm._v(" Remove ")]
              ),
            ]),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }